class PromotionalBar extends HTMLElement {
  
  constructor(){
    super();
    this.listeners();
  }

  listeners(){
    var promotionalClose = document.querySelector('.promotional-bar-close'),
        promotionalBar = document.querySelector('.promotional-bar');

    if (promotionalBar && document.cookie.indexOf('promotional-bar__removed=1') !== -1) {
      promotionalBar.style.display = 'none';
    }

    if (promotionalClose && promotionalBar) {   
      promotionalClose.addEventListener('click', () => {
        promotionalBar.style.display = "none";
        document.cookie = "promotional-bar__removed=1;path=/";
      });
    }
  }
}

customElements.define('promotional-bar', PromotionalBar);
